<div class="container-fluid full-width">

  <div class="ups-component hero has-breadcrumbs">
    <div class="ups-container">
      <div class="card ups-card">
        <div class="card-body fade-in-up-light">
          <div class="card-body-content">
            <h1 class="maj-head0">Notice of Right to Opt Out of Sales, Sharing and Targeted Advertising</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="arc-container">
      <svg xmlns="" width="1440" class="arc" height="72" viewBox="0 0 1440 72" fill="none" aria-hidden="true"
        focusable="false">
        <path d="M-400 176C139.222 -24.794 1028.42 -10.941 1440 13.8751V176L-400 176Z" fill="white"></path>
      </svg>
    </div>
  </div>
  <div class="arc-container">
    <img class="business-services-curved-image" alt="background-arc" src="../../../../assets/redesignImages/Vector.png"
      width="1440" height="0">
  </div>


  <div class="dis-up up-1">
    <p class="subhead">You may submit a request to opt out of the “sale” of personal information about you and/or the
      “sharing” of personal information about you for cross-context behavioral advertising or for purposes of targeted
      advertising.

      To submit an opt-out request, please provide the information below, indicate your opt-out choice(s) and select
      “Submit.”</p>
  </div>


  <div class="container input-form">
    <form class="form-st" #userForm="ngForm" (ngSubmit)="onSubmit()">
      <div class="form-group col lab-0">
        <label for="inputEmail4" class="visible-label">Required Fields <em class="em-style">*</em></label>
      </div>
      <div class="row sp-fm0">
        <div class="col dis_1">
          <input type="text" class="form-control" placeholder="First Name *" id="FirstName" aria-label="First Name *"
            #FirstName="ngModel" [(ngModel)]="user.FirstName" name="FirstName" required>
        </div>
        <div class="col dis_1">
          <input type="text" class="form-control" placeholder="Last Name *" id="LastName" aria-label="Last Name *"
            [(ngModel)]="user.LastName" name="LastName" required>
        </div>
      </div>
      <div class="row sp-fm0">
        <div class="col dis_1 ">
          <input type="text" class="form-control" aria-label="Address Line 1 *" placeholder="Address Line 1 *"
            [(ngModel)]="user.AddressLine1" name="AddressLine1">
        </div>
        <div class="col dis_1 ">
          <input type="text" class="form-control" aria-label="Address Line 2"
            placeholder="Address Line 2 (Apartment, suite, unit, building, floor, etc.)" [(ngModel)]="user.AddressLine2"
            name="AddressLine2">
        </div>
      </div>


      <div class="row sp-fm0">
        <div class="col dis_1 ">
          <input type="text" class="form-control" aria-label="Address Line 3*"
            placeholder="Address Line 3 (Department, c/o, etc.)" [(ngModel)]="user.AddressLine3" name="AddressLine3">
        </div>
        <div class="col dis_1 ">
          <input type="text" class="form-control" aria-label="City *" placeholder="City *" [(ngModel)]="user.City"
            name="City">
        </div>
      </div>

      <div class="row sp-fm0">


        <div class="col dis_1">
          <select id="Country" class="form-select" name="Country" [(ngModel)]="user.Country" required>
            <option value="" selected disabled>Country *</option>
            <option value="US">United States</option>
          </select>
        </div>

        <div class="col col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsState">

          <select id="State" class="form-select" name="State" [(ngModel)]="user.State" required>
            <option value="" class="state-color" disabled selected>State *</option>
            <option value="AK" >Alaska</option>
            <option value="AZ" >Arizona</option>
            <option value="AR" >Arkansas</option>
            <option value="CA" >California</option>
            <option value="CO" >Colorado</option>
            <option value="CT" >Connecticut</option>
            <option value="DE" >Delaware</option>
            <option value="DC" >District Of Columbia</option>
            <option value="FL" >Florida</option>
            <option value="GA" >Georgia</option>
            <option value="HI" >Hawaii</option>
            <option value="ID" >Idaho</option>
            <option value="IL" >Illinois</option>
            <option value="IN" >Indiana</option>
            <option value="IA" >Iowa</option>
            <option value="KS" >Kansas</option>
            <option value="KY" >Kentucky</option>
            <option value="LA" >Louisiana</option>
            <option value="ME" >Maine</option>
            <option value="MD" >Maryland</option>
            <option value="MA" >Massachusetts</option>
            <option value="MI" >Michigan</option>
            <option value="MN" >Minnesota</option>
            <option value="MS" >Mississippi</option>
            <option value="MO" >Missouri</option>
            <option value="MT" >Montana</option>
            <option value="NE" >Nebraska</option>
            <option value="NV" >Nevada</option>
            <option value="NH" >New Hampshire</option>
            <option value="NJ" >New Jersey</option>
            <option value="NM" >New Mexico</option>
            <option value="NY" >New York</option>
            <option value="NC" >North Carolina</option>
            <option value="ND" >North Dakota</option>
            <option value="OH" >Ohio</option>
            <option value="OK" >Oklahoma</option>
            <option value="OR" >Oregon</option>
            <option value="PA" >Pennsylvania</option>
            <option value="RI" >Rhode Island</option>
            <option value="SC" >South Carolina</option>
            <option value="SD" >South Dakota</option>
            <option value="TN" >Tennessee</option>
            <option value="TX" >Texas</option>
            <option value="UT" >Utah</option>
            <option value="VT" >Vermont</option>
            <option value="VA" >Virginia</option>
            <option value="WA" >Washington</option>
            <option value="WV" >West Virginia</option>
            <option value="WI" >Wisconsin</option>
            <option value="WY" >Wyoming</option>
          </select>
        </div>
        <div class="col  col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsZip">
          <input type="text" class="form-control on-full-width zip-pholder" placeholder="Zip Code *"
            [(ngModel)]="user.Zipcode" required name="Zipcode">
        </div>
      </div>

      <div class="row sp-fm0">
        <div class="col dis_1">
          <input type="email" class="form-control" aria-label="Email *" placeholder="Email *" [(ngModel)]="user.Email"
            name="Email">
        </div>
        <div class="col dis_1">
        </div>
      </div>

      <div>
        <label class="bold-header-checkbox">OPT OUT CHOICES: *</label><br>
        <input type="checkbox" id="DoNotSell" name="DoNotSell" #DoNotSell="ngModel" [(ngModel)]="user.DoNotSell">
        <label class="checkbox-label" for="DoNotSell">Do not sell my personal information.</label><br>
        <input type="checkbox" id="DoNotShare" name="DoNotShare" #DoNotShare="ngModel" [(ngModel)]="user.DoNotShare">
        <label class="checkbox-label" for="DoNotShare">Do not “share” my personal information for cross-context
          behavioral advertising or
          for purposes of targeted advertising.</label><br><br>
        <label class="checkbox-label">Additionally, you can manage your cookie settings <a id="cookie-consent" onclick="utag.gdpr.showConsentPreferences();window.scrollTo(0,0);">here</a>. </label><br>
      </div>

      <div class="row sp-fm0">
        <div class="col dis_1">
          <div class="hero-panel-button sli-btn form-submit">
            <button class="get-secret-btn form-sub submit-form" tabindex="-1" type="submit">Submit
            </button>
          </div>
        </div>


      </div>

    </form>
  </div><br><br><br>


  <p></p>
  <p></p>
  <p></p>
</div>